/*
 * Dreamy — vidéos en bulle (fiche produit). Au clic sur une bulle, la vidéo s'ouvre dans une fenêtre <dialog>
 * (format vertical, son et commandes), comme une story Instagram : toucher le tiers gauche = vidéo précédente
 * (ou retour au début sur la première), le reste = vidéo suivante (la fenêtre se ferme après la dernière),
 * appui long = pause, balayage gauche / droite. Aussi par les flèches et le clavier (← →).
 * La vidéo n'est téléchargée qu'à l'ouverture ; elle se met en pause à la fermeture. Échap ferme (natif).
 * Extraits en boucle dans les bulles : lus seulement à l'écran, en pause pendant la grande vidéo,
 * jamais lus si « réduire les animations » est activé (l'image d'aperçu reste).
 * Extraits au survol ([data-ugc-hover], cartes verticales) : avec une souris, lus seulement quand elle est sur la carte
 * (ou au focus clavier), arrêtés et remis au début en sortie. Sur écran tactile (pas de survol, ex. mobile) :
 * lus en boucle comme les bulles, quand la section est à l'écran.
 */
if (!customElements.get('dreamy-ugc')) {
  customElements.define(
    'dreamy-ugc',
    class DreamyUgc extends HTMLElement {
      connectedCallback() {
        this.bubbles = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-src]'));
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('[data-ugc-video]');
        this.bars = this.querySelector('[data-ugc-bars]');
        if (!this.dialog || !this.video || !this.bubbles.length) return;
        this.index = 0;

        this.bubbles.forEach((b, i) => b.addEventListener('click', () => this.open(i)));
        this.dialog.addEventListener('close', () => this.onClose());
        // Clic sur le voile (hors du cadre vidéo) : fermer.
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        this.on('[data-ugc-close]', () => this.dialog.close());
        this.on('[data-ugc-prev]', () => this.go(-1));
        this.on('[data-ugc-next]', () => this.go(1));
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(-1);
          else if (e.key === 'ArrowRight') this.go(1);
        });
        // Vidéo terminée : passer à la suivante (la fenêtre se ferme après la dernière).
        this.video.addEventListener('ended', () => this.go(1));
        this.video.addEventListener('timeupdate', () => this.progress());

        var tap = this.dialog.querySelector('[data-ugc-tap]');
        if (tap) {
          var x0 = 0;
          var held = false;
          var timer = null;
          tap.addEventListener('pointerdown', (e) => {
            x0 = e.clientX;
            held = false;
            clearTimeout(timer);
            timer = setTimeout(() => {
              held = true;
              this.video.pause();
            }, 300);
          });
          var end = (e, cancelled) => {
            clearTimeout(timer);
            if (held) {
              held = false;
              var p = this.video.play();
              if (p && p.catch) p.catch(function () {});
              return;
            }
            if (cancelled) return;
            var dx = e.clientX - x0;
            if (Math.abs(dx) > 50) return this.go(dx < 0 ? 1 : -1);
            var r = tap.getBoundingClientRect();
            this.go(e.clientX - r.left < r.width / 3 ? -1 : 1);
          };
          tap.addEventListener('pointerup', (e) => end(e, false));
          tap.addEventListener('pointercancel', (e) => end(e, true));
          tap.addEventListener('contextmenu', (e) => e.preventDefault());
        }

        var touch = window.matchMedia('(hover: none)').matches;
        var hoverVideos = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-hover]'));
        this.loops = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-loop]')).concat(touch ? hoverVideos : []);
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        if (this.loops.length) {
          if ('IntersectionObserver' in window) {
            new IntersectionObserver((entries) => {
              this.visible = entries[0].isIntersecting;
              this.syncLoops();
            }).observe(this);
          } else this.visible = true;
          this.reduce.addEventListener && this.reduce.addEventListener('change', () => this.syncLoops());
          this.syncLoops();
        }

        hoverVideos.forEach((v) => {
          var card = v.closest('[data-ugc-src]');
          if (!card || touch) return;
          var start = () => {
            if (this.reduce.matches || (this.dialog && this.dialog.open)) return;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          };
          var stop = () => {
            v.pause();
            if (v.readyState) v.currentTime = 0;
          };
          card.addEventListener('mouseenter', start);
          card.addEventListener('mouseleave', stop);
          card.addEventListener('focus', start);
          card.addEventListener('blur', stop);
          card.addEventListener('click', stop);
        });

        if (this.bars)
          this.bars.innerHTML = this.bubbles
            .map(function () {
              return '<span><i></i></span>';
            })
            .join('');
      }

      syncLoops() {
        var play = this.visible && !this.reduce.matches && !(this.dialog && this.dialog.open);
        this.loops.forEach(function (v) {
          if (play) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else v.pause();
        });
      }

      on(selector, fn) {
        var el = this.dialog.querySelector(selector);
        if (el) el.addEventListener('click', fn);
      }

      open(i) {
        this.opener = this.bubbles[i];
        this.load(i);
        if (!this.dialog.open) this.dialog.showModal();
        if (this.loops.length) this.syncLoops();
        document.documentElement.classList.add('dr-ugc-open');
        if (window.Dreamy && Dreamy.track) Dreamy.track('dreamy_ugc_open', { index: i + 1 });
      }

      go(step) {
        var i = this.index + step;
        if (i >= this.bubbles.length) return this.dialog.close();
        if (i < 0) {
          this.video.currentTime = 0;
          var p = this.video.play();
          if (p && p.catch) p.catch(function () {});
          return;
        }
        this.load(i);
      }

      load(i) {
        this.index = i;
        var b = this.bubbles[i];
        this.video.poster = b.dataset.ugcPoster || '';
        this.video.src = b.dataset.ugcSrc;
        this.video.setAttribute('aria-label', b.getAttribute('aria-label') || '');
        this.video.currentTime = 0;
        var p = this.video.play();
        if (p && p.catch) p.catch(function () {});
        b.classList.add('is-seen');
        this.progress();
      }

      progress() {
        if (!this.bars) return;
        var v = this.video;
        var cur = v.duration ? v.currentTime / v.duration : 0;
        var i = this.index;
        Array.prototype.forEach.call(this.bars.children, function (bar, k) {
          bar.firstChild.style.transform = 'scaleX(' + (k < i ? 1 : k === i ? cur : 0) + ')';
        });
      }

      onClose() {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        document.documentElement.classList.remove('dr-ugc-open');
        if (this.loops.length) this.syncLoops();
        if (this.opener) this.opener.focus({ preventScroll: true });
      }
    }
  );
}
